




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Unit } from '../types';


@Component
export default class Bool extends Vue {
  @Prop() private argument!: any;
  @Prop({ default: false }) public readonly disabled!: boolean;
  @Prop({ default: null }) public readonly defaultValue!: any;

  private options = [
    { text: 'No', value: false },
    { text: 'Yes', value: true },
  ];

  get selected() {
    // TODO: Bool default value goes brrr
    return this.defaultValue || false
  }

  set selected(value: any) {
    this.$emit('selected', { [this.argument.name.toString()]: value });
  }

}
